import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import campaignPageQuery from './query.graphql';

const CampaignContent = loadable(() =>
  import(/* webpackChunkName: "campaigns" */ './campaign')
);

const Campaign = props => <CampaignContent {...props} />;

Campaign.graphQL = campaignPageQuery;

Campaign.loadOrder = [{}];

Campaign.variables = variables => {
  const {
    name,
    list,
    min_price, // eslint-disable-line camelcase
    max_price, // eslint-disable-line camelcase
    marketCode,
    ...rest
  } = variables;
  const filters = Object.keys(rest).map(key => ({ key, value: rest[key] }));
  return {
    id: /^\d+$/.test(name) ? parseInt(name, 10) : undefined,
    campaignSlug: name,
    listSlug: list,
    limit: 20,
    minPrice: min_price,
    maxPrice: max_price,
    filters,
    peakIndexCategoryId: rest.category,
  };
};

Campaign.propTypes = {
  fetchMoreData: PropTypes.func,
};

Campaign.defaultProps = {
  fetchMoreData: () => {},
};

Campaign.isGiftGuide = campaign => campaign && campaign.type === 'GIFTGUIDE';

Campaign.isActive = campaign => campaign && campaign.state === 'ACTIVE';

export default Campaign;
